import { Col } from 'reactstrap';
import { Row } from 'reactstrap';
import ScheduleInfo from './parts/ScheduleInfo';
import CoursesInfo from './parts/CoursesInfo';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../locales/translations';
const TeacherScheduleList = () => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);

  return (
    <div className="m-3 pt-2 pb-4 px-3 bg-white rounded">
      <h2 className="text-primary fs-20 fw-700 mt-4">{t(`title`)}</h2>
      <p className="fs-16 mt-3 mb-4">{t(`description`)}</p>
      <Row>
        <Col xs={12}>
          <ScheduleInfo />
        </Col>
        <Col xs={12}>
          <CoursesInfo />
        </Col>
      </Row>
    </div>
  );
};

export default TeacherScheduleList;
